// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'swiper/dist/js/swiper.min.js'
import 'swiper/dist/css/swiper.min.css'
import layer from 'layui-layer'
import Axios from 'axios';//后台交互
//defaults 设置全局默认路径
import apiConfig from '../config/api.config'

// Axios.defaults.baseURL="http://proptype/api_proptype.php/";
// Axios.defaults.baseURL="http://chat.shuyuewangluo.com/api_proptype.php/";
Axios.defaults.baseURL = apiConfig.baseURL;

Vue.prototype.$http=Axios;


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js